// Hooks de Administración · Registro de cambios (T-qtbl, plan §4.2).
// La lista es una useInfiniteQuery sobre el cursor opaco de core-api:
// cada «Cargar más» pide la página siguiente con el `nextCursor` de la
// anterior, y cambiar de chip cambia la clave, así que la pila de páginas
// vuelve a empezar. La exportación es una mutación sin caché: el CSV se
// pide al servidor cada vez, con el mismo filtro que la tabla.

import { useInfiniteQuery, useMutation } from "@tanstack/react-query";
import type { ConfigAuditSection } from "@bitacorapro/api-types";
import { configAuditApi } from "../../../lib/api/endpoints/config-audit";

/** Filas por página; el servidor admite hasta 200. */
export const REGISTRO_PAGE_SIZE = 50;

export const registroQueryKeys = {
  list: (section: ConfigAuditSection | undefined) =>
    ["administracion", "registro", section ?? "todo"] as const,
} as const;

// staleTime 0 (y no los 60 s del QueryClient de main.tsx): el registro
// se abre justo después de cambiar algo en Activos, Mantenciones o
// Enlaces, y ninguna de esas mutaciones invalida esta clave. Cada
// entrada a la pantalla pide la primera página al servidor; mientras
// llega, la caché pinta lo último sin esqueleto (cache-first).
export function useRegistroCambios(section: ConfigAuditSection | undefined) {
  return useInfiniteQuery({
    queryKey: registroQueryKeys.list(section),
    queryFn: ({ pageParam }) =>
      configAuditApi.list({
        section,
        cursor: pageParam ?? undefined,
        limit: REGISTRO_PAGE_SIZE,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
    staleTime: 0,
  });
}

export function useExportarRegistro() {
  return useMutation({
    mutationFn: (section: ConfigAuditSection | undefined) => configAuditApi.csv(section),
  });
}
